export const image = () => (
  <path
    d="M5 21h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2zm0 0l11-11 5 5M5 21l8-8 7.414 7.414M10 8.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
